import { useQuery } from '@tanstack/react-query';

import { getOrderEditLogs } from '~/services/OrdersService';

export const orderEditLogQueryKeys = {
  all: ['orderEditLogs'] as const,
  lists: () => [...orderEditLogQueryKeys.all, 'list'] as const,
  list: (orderId: string, page: number, limit: number) =>
    [...orderEditLogQueryKeys.lists(), orderId, page, limit] as const,
};

export function useGetOrderEditLogs(orderId: string, page = 1, limit = 20, enabled = false) {
  return useQuery({
    queryKey: orderEditLogQueryKeys.list(orderId, page, limit),
    queryFn: () => getOrderEditLogs(orderId, page, limit),
    enabled: !!orderId && enabled,
  });
}
